<template>

  <div class="w-100">

    <div v-if="localSubtitle === ''" class="widget-content p-0 w-100">

        <div class="w-100 align-content-center">{{scale | number}}%</div>
        <div class="progress-bar-xs progress w-100">

          <div class="progress-bar bg-info" :style="{'width':scale+'%'}"></div>
        </div>

    </div>

    <div v-else>

      <div class="widget-content p-0">
        <div class="widget-content-outer">
          <div class="widget-content-wrapper">

            <div class="widget-content-left pr-2">
              <div class="widget-numbers fsize-1 text-info">{{ localSubtitle }}</div>
            </div>

            <div class="widget-content-right w-100">
              <div class="progress-bar-xs progress">
                <div class="progress-bar bg-info" :style="{'width':scale+'%'}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


  </div>



</template>

<script>
export default {
  name: "t-progress-bar-line",
  data() {
    return {
      localSubtitle: "",
      scale: 0,
    }
  },
  props: {
    progress: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 100
    },
    subtitle: {
      type: [String, Number],
      default: ""
    },
  },
  mounted() {

    this.setScale()

    if (this.subtitle !== "" || this.subtitle > 0) {
      this.localSubtitle = this.subtitle
    }


  },
  watch: {

    progress() {

      this.setScale()

    }

  },
  methods: {

    setScale() {
      this.scale = (this.progress / this.total) * 100
    }

  }

}
</script>

<style>

</style>